// extracted by mini-css-extract-plugin
module.exports = {"General":"Interface_General__1jFlw","HorizontalMode":"Interface_HorizontalMode__26P-S","VerticalMode":"Interface_VerticalMode__9MtUe","MobileMode":"Interface_MobileMode__eZNt7"};